<template>
  <div class="plan-summary-mobile d-flex d-lg-none">
    <p v-if="!currentPlan.hash" class="text-muted mb-0">
      {{ emptyText }}
    </p>

    <template v-else>
      <div class="plan-summary-mobile-info">
        <span class="fs-5 fw-bold">{{ currentPlan.name }}</span>
        <span class="fs-5 fw-bold text-primary">
          {{ currentPlan.current_price.amount === 0 ? 'Gratis' : currentPlan.current_price.amount }}
          <span v-if="currentPlan.current_price.amount !== 0" class="fs-7">€</span>
        </span>
      </div>
      <button type="button" class="btn btn-sm btn-light-primary flex-shrink-0" @click="isDrawerOpen = true">
        Mostrar ventajas
      </button>
    </template>
  </div>

  <Teleport to="body">
    <div
        v-if="isDrawerOpen"
        class="plan-summary-drawer-overlay"
        @click="isDrawerOpen = false"
    ></div>
    <aside class="plan-summary-drawer" :class="{ 'is-open': isDrawerOpen }">
      <div class="plan-summary-drawer-header">
        <h3 class="mb-0">{{ title }}</h3>
        <button type="button" class="btn btn-sm btn-icon" @click="isDrawerOpen = false">
          <i class="bi bi-x-lg"></i>
        </button>
      </div>
      <div class="plan-summary-drawer-body">
        <PlanSummaryDetails v-if="currentPlan.hash" :current-plan="currentPlan"/>
      </div>
    </aside>
  </Teleport>
</template>

<script lang="ts">
import {defineComponent, ref} from 'vue';
import PlanSummaryDetails from '~/components/plan-layout/PlanSummaryDetails.vue';

export default defineComponent({
  name: 'PlanSummaryMobile',
  components: {PlanSummaryDetails},
  props: {
    currentPlan: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      default: 'Tu plan',
    },
    emptyText: {
      type: String,
      default: 'Aquí se mostrará el plan seleccionado, el coste y los beneficios.',
    },
  },
  setup() {
    const isDrawerOpen = ref(false);

    return {
      isDrawerOpen,
    };
  },
});
</script>

<style scoped>
.plan-summary-mobile {
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 20px;
  background-color: #f5f6fa;
  border-bottom: 1px solid #eef0f4;
}

.plan-summary-mobile-info {
  display: flex;
  flex-direction: column;
  line-height: 1.2;
}

.plan-summary-drawer-overlay {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.35);
  z-index: 1050;
}

.plan-summary-drawer {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: min(360px, 90vw);
  background-color: #f5f6fa;
  z-index: 1051;
  transform: translateX(100%);
  transition: transform 0.25s ease-in-out;
  overflow-y: auto;
  box-shadow: -8px 0 24px rgba(0, 0, 0, 0.12);
}

.plan-summary-drawer.is-open {
  transform: translateX(0);
}

.plan-summary-drawer-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  border-bottom: 1px solid #e4e6ef;
}

.plan-summary-drawer-body {
  padding: 24px;
}
</style>
